import { FetchStatus, Property, PropertyType } from "../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../base/hooks";
import { IQRScannerProps } from "./IQRScannerProps";
import { useGetPersonId } from "./services/useGetPersonGroupIdPersonId";

export const QRScannerProperties = [
    { id: Property.EnableFaceRecognition, name: 'Face Recognition', type: PropertyType.Boolean },
    { id: Property.VisionPersonGroupId, name: 'Person Group Id', type: PropertyType.String },
    { id: Property.VisionPersonId, name: 'Person Id', type: PropertyType.String },
    { id: Property.Entity, name: 'Entity', type: PropertyType.Entity },
    { id: Property.PortalAction, name: 'Action', type: PropertyType.String },
    { id: Property.PageLink, name: 'Page Link', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
]

export const useQRScannerProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IQRScannerProps>()
    const { data, personGroupData } = useGetPersonId()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings) return;

        // Extract personId and personGroupId from the data
        let personId = '';
        let personGroupId = '';

        if (data && data.length > 0) {
            personId = data[0].personid || '';
        }

        if (personGroupData && personGroupData.length > 0) {
            personGroupId = personGroupData[0].personGroupId || '';
        }

        const attributes: IQRScannerProps = {
            entity: bindings.getValue(Property.Entity),
            title: bindings.getValue(Property.Tooltip),
            pageLink:  bindings.getValue(Property.PageLink),
            action:  bindings.getValue(Property.PortalAction),
            enableFaceRecognition:  bindings.getValue(Property.EnableFaceRecognition),
            personGroupId: personGroupId,
            personId: personId,
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status, data, personGroupData])

    return { status, error, bindings, properties }
}
